export default __webpack_public_path__ + "images/4bab2da1109e4641140a30da2f082c7b-motorcycle.jpg";